import { fallbackString } from "@/shared/utils";

export type DataSourceSixthType =  {
    key: string,
    number: number,
    addDate: string,
    controlActionDate: string,
    GsnActionDate: string,
    ExpirationDate: string,
    assignedPerson:  string,
    infactExpirationDate: string,
    signAssigneeData: string,
};

// Вспомогательная функция для безопасного доступа к вложенным свойствам
function safeGet(obj: any, path: string, defaultValue: any = '') {
    return path.split('.').reduce((current, key) => current?.[key], obj) ?? defaultValue;
}

export function getDataSource(sectionSixData?: any): DataSourceSixthType[] {
    if (!sectionSixData?.sectionSixList) {
        return [];
    }

    return sectionSixData.sectionSixList.map((item: any, index: number) => {
        const gsnInfo = item.gsnInfo?.[0]?.gsnInfo || {};
        const supervisionData = safeGet(gsnInfo, 'infoAboutStateSupervisionList.0.stateSupervisionSignedData.infoAboutStateSupervisionSignedData');
        const assignedPersonWithSignature = safeGet(gsnInfo, 'infoAboutStateSupervisionList.0.stateSupervisionSignedData.stateSupervisionOfficialInfo');
        const supervisionOfficialInfo = safeGet(supervisionData, 'stateSupervisionOfficialInfo');
        return {
            key: item.gsnInfo[0].gsnInfo.infoAboutStateSupervisionList[0].stateSupervisionSignedData.id,
            number: index + 1,
            addDate: fallbackString(item.createDate),
            controlActionDate: fallbackString(safeGet(supervisionData, 'controlEventActInfo.date')),
            GsnActionDate: fallbackString(safeGet(supervisionData, 'controlEventResultsInfo')),
            ExpirationDate: fallbackString(safeGet(supervisionData, 'defectsFixingPlanDateInfo.date')),
        assignedPerson: fallbackString(
          [
            assignedPersonWithSignature?.lastName,
            assignedPersonWithSignature?.firstName,
            assignedPersonWithSignature?.middleName,
          ]
            .filter(Boolean)
            .join(" "),
        ),
        infactExpirationDate: fallbackString(safeGet(gsnInfo, 'infoAboutStateSupervisionList.0.stateSupervisionSignedData.defectsFixingFactDateInfo.date')),
        signAssigneeData: fallbackString(
          [
            supervisionOfficialInfo?.lastName,
            supervisionOfficialInfo?.firstName,
            supervisionOfficialInfo?.middleName,
          ]
            .filter(Boolean)
            .join(" "),
        ),
        };
    });
}